class marmetoShopTheLook extends HTMLElement {
    constructor() {
      super();
      this.hotspots = this.querySelectorAll('.hotspot');
      this.carouselElement = this.querySelector('carousel-component');
      
      // Check if the carousel element exists
      if (!this.carouselElement) {
        console.warn('Carousel component not found within hotspot-carousel.');
        return;
      }
  
      // Set up event listeners for hotspots
      this.setupHotspotListeners();
    }
  
    setupHotspotListeners() {
      this.hotspots.forEach((hotspot) => {
        hotspot.addEventListener('mouseenter', () => {
          const productIndex = hotspot.getAttribute('data-product-index');
        //   console.log(`Hovered on hotspot with index: ${productIndex}`);
  
          // Dispatch custom event to update the carousel
          this.carouselElement.dispatchEvent(
            new CustomEvent('updateSlider', {
              detail: { index: parseInt(productIndex) },
              bubbles: true, // Allow event to bubble up
              composed: true // Allows event to cross the shadow DOM boundary
            })
          );
        });
      });
    }
  }
  
  // Define the custom element
  customElements.define('marmeto-shop-the-look', marmetoShopTheLook);  